import { fetchSupportAvailability } from 'src/services/availability';

// Agent availability action types
export const SET_AGENT_STATUS_LIST = 'SET_AGENT_STATUS_LIST';
export const UPDATE_AGENT_STATUS = 'UPDATE_AGENT_STATUS';
export const AGENT_CONNECTED = 'AGENT_CONNECTED';
export const AGENT_DISCONNECTED = 'AGENT_DISCONNECTED';
// Async fetch action for availability list
export const FETCH_AGENT_STATUS_LIST_REQUEST =
  '@agents/fetch-status-list-request';
export const FETCH_AGENT_STATUS_LIST_FAILURE =
  '@agents/fetch-status-list-failure';

// Action creators
export const setAgentStatusList = (agents) => ({
  type: SET_AGENT_STATUS_LIST,
  payload: { agents }
});

export const updateAgentStatus = (
  staffId,
  status,
  isConnected,
  lastStatusChange
) => ({
  type: UPDATE_AGENT_STATUS,
  payload: { staffId, status, isConnected, lastStatusChange }
});

export const agentConnected = (agent) => ({
  type: AGENT_CONNECTED,
  payload: { agent }
});

export const agentDisconnected = (staffId) => ({
  type: AGENT_DISCONNECTED,
  payload: { staffId }
});

export const fetchAgentStatusList = (botId) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_AGENT_STATUS_LIST_REQUEST });
    try {
      const response = await fetchSupportAvailability(botId);
      const agents = response?.data?.agents || [];
      dispatch(setAgentStatusList(agents));
    } catch (error) {
      dispatch({
        type: FETCH_AGENT_STATUS_LIST_FAILURE,
        payload: {
          error: error?.message || 'Failed to fetch agent status list'
        }
      });
    }
  };
};
